import { Injectable } from '@angular/core';

import { PcvizFeature } from '@mirage-projects/cw-models';

/**
 * Service with helper methods to work with fetures
 */
@Injectable({ providedIn: 'root' })
export class FeatureHelperService {
    /**
     * Returns true if the feature has a valid name
     * @param feature feature
     */
    hasValidName(feature: PcvizFeature): boolean {
        const atName = feature.getAttributeByName('name');
        const isValidName = (atName !== undefined && typeof atName !== 'string') || !!feature.getAttributeByName('name')?.trim();
        return isValidName;
    }
}
